import { Schema } from 'mongoose';
import contractVersion from './contractVersion';

const smartContract = new Schema({
  address: {
    type: String,
    required: true,
  },
  chain: {
    type: String,
    required: false,
  },
  status: {
    type: String,
    required: false,
  },
  version: {
    type: contractVersion,
    required: false,
  },
});

export default smartContract;
